import classnames from "classnames"
import { User, Box, Map, Anchor } from "react-feather"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import Avatar from "@components/avatar"
import { getOceanBookingStats } from "../../ffdashboard/store"
import { Card, CardHeader, CardTitle, CardBody, CardText, Row, Col } from "reactstrap"

const FFStatsCard = ({ cols, data }) => {
    const mainColors = ['info', 'warning', 'primary', 'success']
    const icons = [<Box/>, <Anchor/>, <Map/>, <User/>]

    const statistics = useSelector(state => {
        return state.ffdashboard.statistics
    })

    const totals = [
        {
            title: statistics?.data?.numberofContainersAssigned === 0 ? "0" : statistics?.data?.numberofContainersAssigned,
            subTitle: "Container #",
            color: mainColors[0],
            icon: icons[0]
        },
        {
            title: statistics?.data?.mostCommonSSLine?.id === 0 ? "-" : statistics?.data?.mostCommonSSLine?.id,
            subTitle: "Top SS Line",
            color: mainColors[1],
            icon: icons[1]
        },
        {
            title: statistics?.data?.mostCommonDestination?.id === 0 ? "-" : statistics?.data?.mostCommonDestination?.id,
            subTitle: "Top Destinaton",
            color: mainColors[2],
            icon: icons[2]
        },
        {
            title: statistics?.data?.mostCommonCustomer?.id === 0 ? "-" : statistics?.data?.mostCommonCustomer?.id,
            subTitle: "Top Customer",
            color: mainColors[3],
            icon: icons[3]
        }
    ]

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getOceanBookingStats({
            todaysDate: new Date().toISOString()
        }))
    }, [])

    const getCurrentMonthYear = () => {
        const date = new Date()
        const month = date.toLocaleString('default', { month: 'short' })
        const year = date.getFullYear()
        return `${month} ${year}`
    }

    const renderData = () => {
        return [...totals].map((item, index) => {
            const colMargin = Object.keys(cols)
            const margin = index === 2 ? 'sm' : colMargin[0]
            return (
                <Col
                    key={index}
                    {...cols}
                    className={classnames({
                        [`mb-2 mb-${margin}-0`]: index !== data.length - 1
                    })}
                    >
                    <div className='d-flex align-items-center'>
                        <Avatar color={item.color} icon={item.icon} className='me-2' />
                        <div className='my-auto'>
                        <h5 className='font-small-3 fw-bolder mb-0'>{item.title === "" ? <p className='font-small-3'></p> : item.title}</h5>
                        <CardText className='font-small-3 mb-0'>{item.subTitle}</CardText>
                        </div>
                    </div>
                </Col>
            )
        })
    }

    return (
        <Card className='card-statistics'>
          <CardHeader>
            <CardTitle tag='h4'>Statistics</CardTitle>
            <CardText className='card-text font-small-5 me-25 mb-0'>{getCurrentMonthYear()}</CardText>
          </CardHeader>
          <CardBody className='statistics-body'>
            <Row>{renderData()}</Row>
          </CardBody>
        </Card>
      )
}

export default FFStatsCard